import { render, staticRenderFns } from "./admin-manage.vue?vue&type=template&id=d74d1414&scoped=true"
import script from "./admin-manage.vue?vue&type=script&lang=js"
export * from "./admin-manage.vue?vue&type=script&lang=js"
import style0 from "./admin-manage.vue?vue&type=style&index=0&id=d74d1414&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74d1414",
  null
  
)

export default component.exports